import { render, staticRenderFns } from "./Jylzg.vue?vue&type=template&id=afe3c34c&scoped=true&"
import script from "./Jylzg.vue?vue&type=script&lang=js&"
export * from "./Jylzg.vue?vue&type=script&lang=js&"
import style0 from "./Jylzg.vue?vue&type=style&index=0&id=afe3c34c&lang=less&scoped=true&"
import style1 from "./Jylzg.vue?vue&type=style&index=1&id=afe3c34c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe3c34c",
  null
  
)

export default component.exports